import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../shared/button.component';

import ParamInput from './ParamInput.component';
import ParamSelect from './ParamSelect.component';

import { CustomReportParamTypes } from '../../../shared/customReports/constants';
import { OptionsPropType } from '../../../shared/propTypes/common';

import { paramPropType } from '../../../shared/customReports/propTypes';


class ParamForm extends PureComponent {
  static propTypes = {
    readOnly: PropTypes.bool.isRequired,
    params: PropTypes.arrayOf(paramPropType.isRequired),
    queryParams: PropTypes.objectOf(PropTypes.string.isRequired),
    customReportParamsOptions: PropTypes.objectOf(OptionsPropType),

    updateQueryParams: PropTypes.func.isRequired,
    editParam: PropTypes.func,
  };

  renderParam = param => {
    const {
      updateQueryParams,
      queryParams,
      customReportParamsOptions,
      readOnly,
      editParam,
    } = this.props;

    const key = param.id || param.name;

    const options = customReportParamsOptions && customReportParamsOptions[key]
      ? customReportParamsOptions[key]
      : [];

    return (
      <div className="test-query-form" key={key}>
        <div className="test-form-control">
          {param.type === CustomReportParamTypes.input
            ? <ParamInput
              updateQueryParams={updateQueryParams}
              queryParam={queryParams[key]}
              name={key}
              mappingName={param.mappingName}
            />
            : null
          }
          {param.type === CustomReportParamTypes.query
            ? <ParamSelect
              updateQueryParams={updateQueryParams}
              queryParam={queryParams[key]}
              options={options}
              name={key}
              mappingName={param.mappingName}
            />
            : null
          }
        </div>
        {editParam && param.type !== CustomReportParamTypes.validator
          ? (
            <Button
              type="button"
              kind="primary"
              size="lg"
              className="a-mx-10 edit-button"
              disabled={readOnly}
              onClick={editParam(param.name)}
            >
              Edit
            </Button>
          )
          : null
        }
      </div>
    );
  };

  render() {
    const {
      params,
    } = this.props;

    return (
      <div>
        {params && params.length ? params.map(this.renderParam) : null}
      </div>
    );
  }
}

export default ParamForm;
